/** Maps GET /adresser/{id}. */
export function mapAddressFromAdressevaelgerDto(dto) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const adresse = dto === null || dto === void 0 ? void 0 : dto.adresse;
    if (!(adresse === null || adresse === void 0 ? void 0 : adresse.id_lokalid)) {
        return undefined;
    }
    const husnummer = adresse.husnummer;
    return {
        id: adresse.id_lokalid,
        full: (_a = adresse.adressebetegnelse) !== null && _a !== void 0 ? _a : '',
        floor: adresse.etagebetegnelse || undefined,
        appartmentNumber: adresse.doerbetegnelse || undefined,
        street: (_b = husnummer === null || husnummer === void 0 ? void 0 : husnummer.vejnavn) !== null && _b !== void 0 ? _b : '',
        houseNumber: (_c = husnummer === null || husnummer === void 0 ? void 0 : husnummer.husnummertekst) !== null && _c !== void 0 ? _c : '',
        postNumber: (_e = (_d = husnummer === null || husnummer === void 0 ? void 0 : husnummer.postnummer) === null || _d === void 0 ? void 0 : _d.postnr) !== null && _e !== void 0 ? _e : '',
        city: (_g = (_f = husnummer === null || husnummer === void 0 ? void 0 : husnummer.postnummer) === null || _f === void 0 ? void 0 : _f.navn) !== null && _g !== void 0 ? _g : '',
        // `navn` is the name; the sibling `supplerendebynavn` is a numeric code, so reading
        // the field that shares the object's own name would yield something like "674480".
        area: (_j = (_h = husnummer === null || husnummer === void 0 ? void 0 : husnummer.supplerendebynavn) === null || _h === void 0 ? void 0 : _h.navn) !== null && _j !== void 0 ? _j : undefined,
    };
}
/**
 * Maps a search hit to a prediction.
 *
 * Unlike the DAWA autocomplete there is no `__internal_address` to attach - a hit carries a
 * title and an id only - so the address is fetched when the user picks one.
 */
export function mapAddressPredictionFromAdressevaelgerDto(dto) {
    var _a;
    return {
        id: (_a = dto.id) !== null && _a !== void 0 ? _a : dto.titel,
        text: dto.titel,
    };
}
export function mapAddressFromGoogleDto({ place_id, formatted_address, address_components, }) {
    var _a, _b;
    const street = address_components.find(({ types }) => types.includes('route'));
    const houseNumber = address_components.find(({ types }) => types.includes('street_number'));
    const postNumber = address_components.find(({ types }) => types.includes('postal_code'));
    const city = (_b = (_a = address_components.find(({ types }) => types.includes('sublocality'))) !== null && _a !== void 0 ? _a : address_components.find(({ types }) => types.includes('postal_town'))) !== null && _b !== void 0 ? _b : address_components.find(({ types }) => types.includes('locality'));
    return street && houseNumber && postNumber && city
        ? {
            id: place_id,
            full: formatted_address,
            street: street.long_name,
            houseNumber: houseNumber.long_name,
            postNumber: postNumber.long_name,
            city: city.long_name,
        }
        : undefined;
}
export function mapAddressPredictionFromGoogleDto({ place_id, description, types, }) {
    return types.includes('street_address') || types.includes('premise')
        ? {
            id: place_id,
            text: description,
        }
        : undefined;
}
export function mapFullAddressFromDto(dto) {
    let output = '';
    if (dto.street) {
        output += `${dto.street} `;
    }
    if (dto.buildingNumber) {
        output += `${dto.buildingNumber}, `;
    }
    if (dto.buildingFloor) {
        output += `${dto.buildingFloor}, `;
    }
    if (dto.buildingDoor) {
        output += `${dto.buildingDoor}, `;
    }
    if (dto.cityArea) {
        output += `${dto.cityArea}, `;
    }
    if (dto.zip) {
        output += `${dto.zip} `;
    }
    if (dto.city) {
        output += `${dto.city} `;
    }
    if (dto.country) {
        output += `${dto.country}`;
    }
    return output.trim();
}
